export const ANNOTATION_PROPS = {
  HIGHLIGHT_TAG_NAME: "span",
  ANNOTATION_TYPE_ATTRIBUTE_NAME: "data-annotation-type",
  ANNOTATION_ID_ATTRIBUTE_NAME: "data-annotation-id",
  ANNOTATION_ICONS_CONTAINER_CLASS_NAME: "annotation-icons-container",
  ANNOTATION_ICON_CLASS_NAME: "annotation-icon",
  ANNOTATION_SHAREABLE_ICON_CLASS_NAME: "shareable-icon",
  ANNOTATION_NOTE_ICON_HANDLER_CLASS_NAME: "note-icon",
  ANNOTATION_FLASHCARD_ICON_HANDLER_CLASS_NAME: "flashcard-icon",
  ANNOTATION_HIGHLIGHT_CLASS_NAME: "annotation-text-highlight",
  ANNOTATION_FLASHCARD_CLASS_NAME: "annotation-text-flashcard",
  ANNOTATION_MATH_ML_CLASS_NAME: "annotation-mathml",
  ANNOTATION_TYPE_FLASHCARD: "Flashcard",
  ANNOTATION_TYPE_NOTE: "Note",
};

export const TOUCH_EVENTS = {
  touchend: "touchend",
  pointerup: "pointerup",
  selectionchange: "selectionchange",
};

export const SELECTION_DISABLED_CLASSNAMES = ".acs-assessment-provider";
